import { FormControl, FormGroupDirective, NgForm } from "@angular/forms";
import { ErrorStateMatcher } from "@angular/material/core";
import { FormControlService } from "./form-control.service";

export class FormControlErrorStateMatcher implements ErrorStateMatcher {
    private readonly _formControlService: FormControlService

    constructor(getter: () => FormControlService
    ) {
        this._formControlService = getter();
    }

    isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
        return !Boolean(this._formControlService.brokenRulesSubject.value?.length)
    }
}